import script from "./ColorPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColorPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ColorPreview.vue?vue&type=style&index=0&id=477132a5&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-477132a5"]])

export default __exports__